export interface ControlsProps {
  children?: React.ReactNode;
}

/**
 * Component to wrap a collection of map control components
 * Does not actually render anything, but instead allows the controls to be declared in markup fashion
 * @component
 * @param {React.ReactNode} children - the children components to render
 * @example
 * <Map center={center} zoom={zoom} projection={Epsg27700}>
 *   ...
 *   <Controls>
 *     <FullScreen />
 *   </Controls>
 * </Map>
 */
const Controls = ({ children }: ControlsProps) => {
  return <>{children}</>;
};

export default Controls;
